<app-header></app-header>

<ion-content>
  <div class="breadcrumb-margin" *ngIf="!p.renderMobile">
    <app-breadcrumb></app-breadcrumb>
  </div>

  <ng-container *ngIf="!isError; else HTTPError">
    <ion-grid
      [ngClass]="{'display-none': loading }"
      class="no-padding-grid-box"
    >
      <ion-row justify-content-center>
        <ion-col size="12" size-xl="5">
          <app-card title='{{ "REPORT_TASK.EDIT_TASK" | translate }}'>
            <app-report-task-detail
              *ngIf="reportTaskServ.reportTask"
              mobileViewBreakPoint="1750"
            >
            </app-report-task-detail>
          </app-card>
        </ion-col>
        <ion-col size="12" size-xl="7">
          <app-report [statusVisable]="false"></app-report>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="REPORT_TASK.TASK"
      returnText="REPORT_TASK.RETURN_TO_REPORT_TASK"
      link="app/report-task"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ng-template>
  <app-loading-sti *ngIf="loading"></app-loading-sti>
</ion-content>
